module.exports = __webpack_public_path__ + "media/images/design/images/shi-match_banner-1af863d0027b197059e2b23790be033b.jpg";